import Vue from 'vue';
import Vuelidate from 'vuelidate';
import App from './App.vue';
import vuetify from './plugins/vuetify';

import store from './store';
import router from './router';
import i18n from './i18n';

import security from './services/security';

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next();
  }
  else if (to.path === '/oidc-code') {
    next();
    store.commit('security/TOGGLE_LOGGING_IN');
    fetch(security.handleCodeRedirect(to.query))
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        store.dispatch('security/setToken', { accessToken: data.access_token })
          .then(() => {
            store.commit('security/TOGGLE_LOGGING_IN');
            router.push('/');
          });
      });
  }
  else if ( ! store.getters['security/isAuthenticated']) {
    next({ name: 'Login' });
  } else {
    next();
  }
});

Vue.use(Vuelidate);

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
